<template>
  <div class="project-logic-container">
    <div class="show-logic-container">
      <div v-for="(logicItem, index) in logicList" :key="logicItem.id" class="logic-item">
        <div class="logic-item-delete" @click="handleRemoveLogicItem(index)">
          <i class="el-icon-delete" />
        </div>
        <el-row
          v-for="(cItem, cIndex) in logicItem.conditions"
          :key="cIndex"
          :gutter="20"
          align="middle"
          class="mt5"
          justify="center"
          type="flex"
        >
          <el-col :span="3" class="text-center">
            <span v-if="cIndex === 0">如果：</span>
            <el-select
              v-else
              v-model="logicItem.relation"
              :disabled="cIndex !== 1"
              @change="(val) => relationChangeHandle(val, logicItem)"
            >
              <el-option label="并且" value="AND" />
              <el-option label="或者" value="OR" />
            </el-select>
          </el-col>
          <el-col :span="7">
            <el-select v-model="cItem.type" @change="handleClearExpression(cItem)">
              <el-option label="题目" value="_TITLE" />
              <el-option label="外部参数" value="_PARAMETERS" />
            </el-select>
          </el-col>
          <el-col :span="7">
            <el-select
              v-if="cItem.type === '_PARAMETERS'"
              v-model="cItem.parameter"
              placeholder="请选择参数"
              style="width: 80%"
            >
              <el-option label="菜品编码" value="product" />
            </el-select>

            <el-cascader
              v-else
              v-model="cItem.formItemId"
              :options="getConditionProjectItemList(logicItem)"
              :filterable="true"
              :show-all-levels="false"
              placeholder="请选择题目"
              @change="handleConditionChange(cItem)"
              :props="{
                expandTrigger: 'hover',
                emitPath: false
              }"
            >
            </el-cascader>
          </el-col>
          <el-col :span="5">
            <el-select v-model="cItem.expression" placeholder="请选择条件">
              <el-option
                v-for="item in getConditionOptions(cItem)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="6">
            <!--  评分使用数字框-->
            <el-input-number
              v-if="['NPS', 'RATE'].includes(getFormItemIdType(cItem.formItemId))"
              v-model="cItem.optionValue"
              :min="0"
            />
            <el-button
              type="text"
              @click="openkeywordDialogHandle(cItem)"
              v-else-if="checkoIsInput(cItem.formItemId) || cItem.type == '_PARAMETERS'"
            >
              设置关键词
            </el-button>
            <el-select v-else v-model="cItem.optionValue" placeholder="请选择选项">
              <el-option
                v-for="item in getFormItemOptions(cItem.formItemId)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-button type="text" @click="addConditionHandle(logicItem, cItem)">
              <i class="el-icon-circle-plus-outline" />
            </el-button>
            <el-button
              v-if="cIndex !== 0"
              class="remove"
              type="text"
              @click="removeConditionHandle(logicItem, index, cIndex)"
            >
              <i class="el-icon-remove-outline" />
            </el-button>
          </el-col>
        </el-row>
        <el-divider />
        <el-dialog title="设置关键词" :visible.sync="dialogVisible" width="30%">
          <span class="desc-text">每行一个关键词，不需要标点符号</span>
          <el-input
            class="mt-10"
            v-model="batchItemValue"
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 5000 }"
            placeholder="关键词1"
          />
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="keywordEditSelectItems">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { jsonSimpleClone } from '@/utils'
import { getFormLogicRequest, listProjectItemRequest, saveFormLogicRequest } from '@/api/project/form'
import { debounce } from 'throttle-debounce'
import { conditionOptions, parameterOptions } from './config'

export default {
  name: 'LogicForm',
  components: {},
  props: {
    formKey: {
      type: String,
      default: ''
    },
    conditionList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      saveMessage: '',
      isSave: 'info',
      isLoading: false,
      batchItemValue: '',
      // 默认逻辑结构
      defaultLogicItem: {
        // 逻辑条件
        // 关系
        relation: 'AND',
        conditions: [
          {
            // 条件类型:题目 _TITLE、外部参数_PARAMETERS
            type: '',
            // 问题
            formItemId: null,
            // 条件 == > < >= <=
            expression: null,
            // 值
            optionValue: null,
            // 外部参数
            parameter: 'product',
            //
            parameterValue: ''
          }
        ]
      },
      conditionOptions,
      parameterOptions,
      allProjectItemList: [],
      allProjectHasGroupListL: [],
      logicList: [],
      activeItem: {},
      dialogVisible: false // 包含关键词弹窗
    }
  },
  watch: {
    formKey: function (val) {
      this.initLogicList()
      if (val) {
        this.queryProjectItems()
      }
    }
  },
  mounted() {
    this.logicList = jsonSimpleClone(this.conditionList)
    this.queryProjectItems()
  },
  methods: {
    initLogicList() {
      this.logicList = []
    },
    openkeywordDialogHandle(cItem) {
      this.batchItemValue = cItem.optionValue
      this.activeItem = cItem
      this.dialogVisible = true
    },
    async keywordEditSelectItems() {
      this.$set(this.activeItem, 'optionValue', this.batchItemValue)
      this.dialogVisible = false
    },
    addConditionHandle(logicItem, cItem) {
      logicItem.conditions.push({})
    },
    removeConditionHandle(logicItem, logicIndex, index) {
      logicItem.conditions.splice(index, 1)
    },
    addLogicHandle() {
      this.isLoading = true
      let newLogicItem = jsonSimpleClone(this.defaultLogicItem)
      newLogicItem.id = new Date().getTime()
      this.logicList.push(newLogicItem)
    },
    // 参数类型改变时 reset 逻辑条件
    handleClearExpression(cItem) {
      this.$set(cItem, 'expression', null)
      this.$set(cItem, 'optionValue', null)
      if (cItem.type === '_TITLE') {
        this.$set(cItem, 'parameter', 'product')
      } else {
        this.$set(cItem, 'formItemId', null)
      }
    },
    getConditionOptions(cItem) {
      const formItemId = cItem.formItemId
      let opts = []
      if (cItem.type == '_TITLE') {
        if (!formItemId) return []
        opts = this.getOptions(formItemId)
      } else {
        opts = jsonSimpleClone(this.parameterOptions)
      }
      return opts
    },
    getOptions(formItemId) {
      // 截取第一个数字前面的字符串
      let type = formItemId.replace(/(\D+)\d+.*/, '$1').toUpperCase()
      let conditionOptions = jsonSimpleClone(this.conditionOptions)
      const isInputOrText = this.checkoIsInput(formItemId)
      if (type === 'RATE' || type === 'NPS') {
        // 移除前两个选项
        conditionOptions.splice(0, 3)
      } else if (isInputOrText) {
        conditionOptions = conditionOptions.splice(2, 1)
      } else if (type === 'CHECKBOX') {
        conditionOptions = conditionOptions.splice(1, 1)
      } else if (type === 'IMAGE_SELECT') {
        let formItem = this.allProjectItemList
          .flatMap((group) => group.items)
          .find((item) => item.formItemId == formItemId)
        conditionOptions = formItem.scheme.multiple ? conditionOptions.splice(1, 1) : conditionOptions.splice(0, 1)
      } else {
        conditionOptions.splice(1, 6)
      }
      return conditionOptions
    },
    // 处理逻辑连接 只允许同时and 或者同时OR 负责逻辑会冲突
    relationChangeHandle(val, logicItem) {
      // logicItem.conditions.forEach((item) => {
      //   item.relation = val
      // })
    },
    formatCascaderOptions(list) {
      console.log(list)
      return list.map((group) => ({
        value: group.formItemGroupId, // 父节点使用 formItemGroupId
        label: group.name,
        children: group.items.map((item) => ({
          value: item.formItemId, // 子节点使用 id
          label: item.questionNumber ? `${item.questionNumber}.${item.textLabel}` : item.textLabel
        }))
      }))
    },
    // 获取条件可选择问题
    getConditionProjectItemList(logicItem) {
      // 作为逻辑的结果显示问题不能作为条件问题·
      const list = jsonSimpleClone(this.allProjectItemList).map((group) => ({
        ...group,
        items: group.items.filter((item) =>
          ['RADIO', 'CHECKBOX', 'SELECT', 'IMAGE_SELECT', 'RATE', 'NPS', 'INPUT', 'TEXTAREA'].includes(item.type)
        )
      }))
      return this.formatCascaderOptions(list)
    },
    /**
     * 获取选择问题的选项
     * @param formItemId
     * @returns {*[]|*}
     */
    getFormItemOptions(formItemId) {
      const formItem = this.allProjectItemList
        .flatMap((group) => group.items)
        .find((item) => item.formItemId == formItemId)
      return formItem?.scheme?.config?.options || []
    },
    // 逻辑题目修改reset 条件、选项、显示项
    handleConditionChange(cItem) {
      this.$set(cItem, 'optionValue', null)
      this.$set(cItem, 'expression', null)
      this.batchItemValue = ''
    },
    handleRemoveLogicItem(index) {
      this.logicList.splice(index, 1)
    },
    getFormItemIdType(formItemId) {
      if (!formItemId) return ''
      return formItemId.replace(/(\D+)\d+.*/, '$1').toUpperCase()
    },
    checkoIsInput(formItemId) {
      if (!formItemId) return ''
      const type = formItemId.replace(/(\D+)\d+.*/, '$1').toUpperCase()
      return type === 'INPUT' || type === 'TEXTAREA'
    },
    //
    queryProjectItems() {
      listProjectItemRequest({ key: this.formKey }).then((res) => {
        this.allProjectItemList = res.data
          .map((group) => ({
            ...group,
            items: group.items?.filter((item) => item.type !== 'PAGINATION') || []
          }))
          .filter((group) => group.items.length > 0)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.project-logic-container {
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;

  .scrollbar-container {
    height: 100%;
  }

  .header-row {
    width: 230px;
    margin-bottom: 20px;
  }

  .logic_title {
    font-size: 18px;
    height: 45px;
    line-height: 45px;
    color: #484848;
    text-align: left;
    margin-top: 20px;
  }
}

.text-desc {
  font-size: 14px;
  line-height: 20px;
  color: #9b9b9b;
  margin-bottom: 10px;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.not-logic-container {
  .el-icon-circle-plus-outline {
    font-size: 20px;
  }

  .label {
    font-size: 18px;
  }
}

.logic-item-container {
  .tips {
    font-size: 14px;
    color: #aaa;
  }

  .label {
    font-size: 15px;
  }

  .remove {
    color: #ff4949;
  }
}

.show-logic-container {
  padding: 20px;
  min-width: 90%;
  background-color: #fff;
  height: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 24px;
}

.logic-item {
  position: relative;

  .logic-item-delete {
    position: absolute;
    right: 20px;
    top: -15px;
    color: #ff4d4f;
    cursor: pointer;
  }
}
</style>
